import { FieldModel, PaginationResponse, ProgramModel, WorkflowItem } from '@cibo/core'
import { PageLink } from '../../../components/SecondaryNavigation'

export type PageLinks = Record<'enrolled' | 'enrollments' | 'eligible' | 'about', PageLink>

export const collatePageLinks = ({
  pageLinks,
  enrolled,
  enrollments,
  program,
  eligible,
}: {
  pageLinks: PageLinks
  enrolled?: PaginationResponse<FieldModel>
  enrollments?: PaginationResponse<WorkflowItem>
  program?: ProgramModel
  eligible?: PaginationResponse<FieldModel>
}) => {
  const actualPageLinks = []

  if (program?.isClosedForEnrollment) {
    if (!!enrolled?.numAvailable) {
      actualPageLinks.push(pageLinks.enrolled)
    }
    if (!!enrollments?.numAvailable) {
      actualPageLinks.push(pageLinks.enrollments)
    }
    if (!!actualPageLinks.length) {
      actualPageLinks.push(pageLinks.about)
    }
  } else if (program?.isFuture) {
    if (!!eligible?.numAvailable) {
      actualPageLinks.push(pageLinks.eligible, pageLinks.about)
    }
  } else {
    actualPageLinks.push(...Object.values(pageLinks))
  }
  return actualPageLinks
}
